<template>
  <div class="index  page_map page_map_qg">
    <!-- <div class="index_top">
	  <div class="PageSearch page-search">
		  <van-row type="flex" justify="space-start">
			<van-col v-if="searchlefticon" class="left_col">
				<van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" @click="clicksearchleft" />
			</van-col>
			<van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
				<van-cell-group  class="search_field">
					<van-field v-model="search_value" :readonly="readonly" :placeholder="placeholder" @focus="showFullScreenSearchPage">
						<van-icon slot="right-icon" :name="righticon" />
					</van-field>
				</van-cell-group>
			</van-col>
			<van-col v-if="searchrighticon != ''" class="right_col">
				<van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" @click="clicksearchright" />
			</van-col>
		</van-row>
	  </div>
    </div> -->
    <!-- 地图区域 -->
    <div class="mapwrap">
      <!-- 地图容器 -->
      <div id="container" :class="'container' + type_id"></div>
      <!-- 全国 | 周边 -->
      <div class="range">
        <span class="item active" @click="goBackQuanguo">全国</span>
        <span class="item" @click="goZhoubian">周边</span>
      </div>
    </div>
    <!-- 右侧 分类 -->
    <!-- <div class="fenlei_r">
            <ul class="list">
                <li class="item">首页</li>
                <li class="item">复购</li>
                <li class="item">助力</li>
            </ul>
        </div> -->
    <!-- 项目统计 -->
    <div class="tongji">
      <van-swipe
        :show-indicators="false"
        :touchable="false"
        ref="swipe"
        @change="changeFun"
      >
        <van-swipe-item v-for="item in typeList" :key="item.type_id">
          <div class="title" :style="'background:' + color.top1">
            <!-- <span class="prev" @click="clickPrev"></span>平台{{
              item.name
            }}项目统计{{ str ? "(" + str + ")" : ""
            }}<span class="next" @click="clickNext"></span> -->
			<span class="prev" @click="clickPrev"></span>平台{{
              currentName
            }}项目统计{{ str ? "(" + str + ")" : ""
            }}<span class="next" @click="clickNext"></span>
          </div>
		  	<van-tabs v-model="level_id" @change="changeLevel" class="levels" :border="false" :swipe-threshold="3">
				<van-tab v-for="(level,key) in levelArr" :key="key" :name="level.id">
					<template #title>
						{{level.title}}
					</template>
				</van-tab>
			</van-tabs>
			<!-- <div class="levels" v-if="level_id" @click="changeLevel">
				<div class="van-tabs__wrap">
					<div class="van-tabs__nav">
						<div class="van-tab" v-for="(level,key) in levelArr" :key="key" :name="level.id">{{ level.title }}</div>
					</div>
				</div>
			</div> -->
			<ul class="list">
				<li :class="item.span == 2 ? 'item span2': 'item span1'" v-for="(item,index) in dataList" :key="index" @click="goItem(item)">{{item.name+'('+ item.num+')'}}</li>
			</ul>
          <!-- <ul class="list clearfix">
			<li class="item f-l" v-for="(item,index) in dataList" :key="index" @click="goItem(item)">{{item.name+'('+ item.num+')'}}</li>
            <li
              v-for="(item, index) in dataList"
              :key="index"
              :class="'item f-l span' + item.span"
              @click="goItem(item)"
            >
              {{ item.name + "(" + item.num + ")" }}
            </li>
          </ul> -->
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
import { parse } from 'path';
// import { DistrictCluster } from 'vue-amap'; // 使用vue-amap插件，要引用
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    name: "map-quanguo",
    data() {
        return {
			searchlefticon: '', // 搜索栏左侧图标
			searchrighticon: '', // 搜索栏右侧图标
			search_value: '', // 搜索值
			readonly: true, // 搜索栏只读
			placeholder: '项目搜索',
			righticon: process.env.BASE_URL+'statics/images/search_ico.png', // 搜索框搜索图标
			levelArr: [], // 分类级别
			level_id: null, // 分类级别id
			str: '北京', // 默认北京
            publicPath: process.env.BASE_URL,
            areaList: null, //
            dataList: [
                // {
                //     "id": 1,
                //     "name": "民间文学",
                //     "num": 1252
                // },
                // {
                //     "id": 2,
                //     "name": "民间音乐",
                //     "num": 1692
                // },
                // {
                //     "id": 3,
                //     "name": "民间舞蹈",
                //     "num": 1875
                // }
            ], // 数据
            typeList: [ // 项目分类
                // {
                //     "type_id": 0,
                //     "name": "非遗"
                // },
                // {
                //     "type_id": 1,
                //     "name": "百村"
                // },
                // {
                //     "type_id": 5,
                //     "name": "民宿"
                // },
                // {
                //     "type_id": 3,
                //     "name": "景区"
                // }
            ],
            markerGroups: [
                // {
                //     id: 1,
                //     position: [115.658449,37.689046],
                //     icon: process.env.BASE_URL + 'statics/images/icon_maptip.png',
                //     content: '衡水植物园',
                // },
                // {
                //     id: 2,
                //     position: [115.653292,37.649961],
                //     icon: process.env.BASE_URL + 'statics/images/icon_maptip.png',
                //     content: '衡水动物园',
                // }
            ],
            type_id: 0, // 默认是0 对应非遗项目
			// color: 'rgba(219, 31, 31, 1)',
            color: {
            		'top1': 'rgba(219, 31, 31, 1)'
			},
			allCoordinates: [] , // 坐标点汇总
			mapIcons: {
				icon0: process.env.BASE_URL + "statics/images/maptip_0.png",
				icon1: process.env.BASE_URL + "statics/images/maptip_1.png",
				icon2: process.env.BASE_URL + "statics/images/maptip_2.png",
				icon3: process.env.BASE_URL + "statics/images/maptip_3.png",
				icon4: process.env.BASE_URL + "statics/images/maptip_4.png",
				icon5: process.env.BASE_URL + "statics/images/maptip_5.png",
			},
			map: null, // 地图实例
			token: '',
			shareConfig: null, // 分享的相关配置
			area_name: null, // 地区名称 例子 [河北省，衡水市]
			currentName: null,
			init: true // true默认,false已点选
        };
    },
    components: {
        PageSearch
    },
    created: function () {
		if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '全国地图'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    
                } else {
                    this.token = ''
                }
				this.getLevelList(this.type_id)
				var that = this
        		this.getTypeList(function(res){
					that.typeList = res.result
					that.currentName = res.result[0].name
				})
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
			this.getLevelList(this.type_id)
			var that = this
			this.getTypeList(function(res){
				that.typeList = res.result
				that.currentName = res.result[0].name
			})
			
			// this.getShareData()
        }
		
    },
    mounted() {
        // console.log('高德地图插件')
        this.diaoqi()
    },
    methods: {
        // 打开周边非遗
        goZhoubian() {
			// 
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://public/back', memberParams, (data) => {
                    
                })
            } else {
				this.$router.push({
					name: 'map'
				})
			}
        },
        // 行政区域聚合初始化
        initPage(DistrictCluster, $, utils, color) {
            console.log('color',color)
            var that = this
            that.map = new AMap.Map('container', {
				resizeEnable: true, //是否监控地图容器尺寸变化
				zoom: 4, // 4 显示省边界 
				// center:[103.984424,41.208757]
			});
			that.map.on('dragend', function (e){
				console.log('拖拽')
				console.log(that.map.getCenter())
			})
			// 在地图上先选择覆盖物,默认北京
			that.defaultAreaMarker()
			// 可以设置显示范围
			// var mybounds = new AMap.Bounds([159.47947,62.13396],[71.852516,1.733975]);
			// var bounds = that.map.setBounds(mybounds);
			// that.map.setLimitBounds(bounds);
			// that.map.setBounds(mybounds);
            // 自定义绘制引擎
            function MyRender(distClusterIns, opts) {
                //直接调用父类的构造函数
                MyRender.__super__.constructor.apply(this, arguments);
            }
            //继承默认引擎
            utils.inherit(MyRender, DistrictCluster.Render.Default);
            utils.extend(MyRender.prototype, {
                drawFeaturePolygons: function (ctx, polygons, styleOptions, feature, dataItems) {
                    //调用父类方法
                    MyRender.__super__.drawFeaturePolygons.apply(this, arguments);
                    //直接绘制聚合信息
                    this.drawMyLabel(feature, dataItems);
                },
                _initContainter: function () {
                    //调用父类方法
                    MyRender.__super__._initContainter.apply(this, arguments);

                    //创建一个新的canvas
                    this._createCanvas('mylabel', this._container);
                },
                /**
                 * 绘制一个白底黑字的label替代聚合标注
                 */
                drawMyLabel: function (feature, dataItems) {
					// console.log('dataItems')
					// console.log(dataItems)
					// console.log('this')
					// console.log(this)
                    var pixelRatio = this.getPixelRatio(); //高清下存在比例放大
                    var containerPos = that.map.lngLatToContainer(feature.properties.centroid || feature.properties.center);
                    var labelCtx = this._getCanvasCxt('mylabel');
                    //文字的中心点
                    var centerX = containerPos.getX() * pixelRatio,
                        centerY = containerPos.getY() * pixelRatio;
                    labelCtx.save();
                    labelCtx.font = 12 * pixelRatio + 'px 微软雅黑';
					var text = feature.properties.name.slice(0, 2);
					// var text = feature.properties.name+ ' (' + dataItems.length + ')';
                    var textMetrics = labelCtx.measureText(text);
                    var halfTxtWidth = textMetrics.width / 2;
                    labelCtx.fillStyle = 'transparent';
                    //绘制一个蓝色背景
                    // labelCtx.fillRect(centerX - halfTxtWidth - 3 * pixelRatio,
                    //     centerY - 11 * pixelRatio,
                    //     textMetrics.width + 6 * pixelRatio,
					//     22 * pixelRatio);
					// 文字填充颜色
					// labelCtx.fillStyle = '#000000';
					labelCtx.fillStyle = 'transparent'
                    labelCtx.textBaseline = 'middle';
                    labelCtx.fillText(text, centerX - halfTxtWidth, centerY);
                    labelCtx.restore();
                }
            });
            // 创建 distCluster 实例
            var distCluster = new DistrictCluster({
                map: that.map, //所属的地图实例
				zIndex: 11,
				autoSetFitView: false, // 是否在绘制后自动调整地图视野以适合全部点，默认true ；设置为false就不会自动调整视野，定位点
				getPosition: function (item) { // 返回数据项中的经纬度信息
					// console.log('item')
					// console.log(item)
                    if (!item) {
                        return null;
					}
                    var parts = item.split(',');
                    //返回经纬度
					return [parseFloat(parts[1]), parseFloat(parts[0])];
				},
				//使用自定义的引擎类
				renderConstructor: MyRender,
				// 配置区块渲染属性
                renderOptions: {
					//不再使用聚合标注
					getClusterMarker: null,
					//点击区划面后切换到子级区划
					featureClickToShowSub: true,
                    //基础样式
                    featureStyle: {
                        fillStyle: 'rgba(255,250,237)', //填充色 rgba(0,0,0,0.5)
                        lineWidth: 1, //描边线宽
                        strokeStyle: 'rgb(185, 189, 191)', //描边色 // 255, 255, 255
                        //鼠标Hover后的样式
                        hoverOptions: {
                            // fillStyle: 'rgba(0,0,0,1)'
                        }
                    },
                    //特定区划级别的默认样式 优先级高于 featureStyle
                    featureStyleByLevel: {
                        //全国
                        country: {
                            fillStyle: 'rgba(255,250,237)' // color.top1
                        },
                        //省
                        province: {
                            fillStyle: 'rgba(255,250,237)' // color.top1
                        },
                        //市
                        city: {
                            fillStyle: 'rgba(255,250,237)' // color.top1
                        },
                        //区县
                        district: {
                            fillStyle: 'rgba(255,250,237)' // color.top1
                        }
                    }
                },
                //标注信息Marker上需要监听的事件
                // clusterMarkerEventNames: ['click', 'rightclick', 'mouseover', 'mouseout']
            });
			window.distCluster = distCluster;
            // 鼠标点击feature对应的区域时触发
            distCluster.on('featureClick', function (e, feature) {
				// 取消默认init 设置为false
				that.init = false
				// 设置zoom
				that.map.setZoom(4)
				// console.log(that.map.getZoom())
				console.log(that.map.getCenter())
				that.map.setCenter(feature.properties.center)
				// distCluster.topAdcodes = [feature.properties.adcode]
                console.log("feature111111")
				console.log(feature)
				var arr = []
				if(feature.properties.level == 'province'){
					var name = feature.properties.name
					name = name.replace('市','') // 对应后台数据 北京市-- 北京 天津市--天津 上海市--上海 ..
					console.log('name',name)
                    arr.push(name)
                }else if(feature.properties.level == 'city') {
					arr.push(feature.properties.name)
					arr.unshift('省')
                    // arr = str.split('>')
                    // console.log(arr)
            	}else{
					return
				}
				that.areaList = arr
				var str = arr[arr.length-1]
				that.str = str
				console.log(that.areaList)
				console.log(str)
				console.log('地图调了getData')
				// that.getData(that.type_id,arr)
				// console.log(arr)
				console.log('1111')
				var params = {
					token: that.token,
					type_id: that.type_id,
					area_name: arr,
					area_level: arr.length,
					level_id: that.level_id
				}
				that.area_name = arr
				that.$api.map.areaItem(params).then(res => {
					// console.log('1')
					if (res.code == 200) {
						console.log('res')
						console.log(res)
						var markers = []
						var markerGroups = res.result.itemList
						that.dataList = res.result.cateList;
						// 排序
						var newD = that.dataList
						var arr1 = new Array()
						var arr2 = new Array()
						for(var i in newD){
							var str = newD[i].name+'('+ newD[i].num + ')'
							if(that.getStrLength(str)>12){
								newD[i].span = 2
								arr1.push(newD[i])
							}else{
								newD[i].span = 1
								arr2.push(newD[i])
							}
						}
						that.dataList = arr1.concat(arr2)

						// console.log('地图坐标点')
						// console.log(this.markerGroups)
						console.log('覆盖物组数据')
						console.log(markerGroups)
						// 添加覆盖物
						for(var i in markerGroups){
								// 创建点实例
								var marker = new AMap.Marker({
									position: new AMap.LngLat(markerGroups[i].xcoordinate,markerGroups[i].ycoordinate),
									icon: that.type_id == 1 ? that.mapIcons.icon4 : that.type_id == 2 ? that.mapIcons.icon3 : that.type_id == 3 ? that.mapIcons.icon5 : that.mapIcons.icon0,
									extData: {
										id: markerGroups[i].id,
										title: markerGroups[i].title
									},
									map:that.map
								})
								markers.push(marker);
						}
						// console.log('markers')
						// console.log(markers)
						// 给覆盖物绑定事件
						for(var i in markers){
							markers[i].on('click',function(e){
								console.log('click')
								console.log(e.target.getExtData())
								that.goItemInfo(e.target.getExtData().id)
							})
						}
						// 清除地图上的所有覆盖物
						that.map.clearMap(); 
						// 给当前区域加覆盖物
						var overlayGroups = new AMap.OverlayGroup(markers);
						that.map.add(overlayGroups);
					}
				})
			})
			// 获取坐标点汇总
			that.$api.map.allCoordinates({
				token: that.token,
				type_id: that.type_id
			}).then(res=>{
				if(res.code == 200){
					// console.log('code 200')
					// var data = res.result
					var data = that.formatArr(res.result)
					// console.log('data地图')
					// console.log(data)
					distCluster.setData(data);
				}
			})
        },
        // 调起行政区域聚合
        diaoqi: function () {
            var that = this
            //加载相关组件
            AMapUI.load(['ui/geo/DistrictCluster', 'lib/$', 'lib/utils'], function (DistrictCluster, $, utils) {
                window.DistrictCluster = DistrictCluster;
                //启动页面
                that.initPage(DistrictCluster, $, utils, that.color);
            });
        },
        // 调中国地图后台接口 获取数据
        getData(type_id,level_id,area_name) {
			var that = this;
            var params = {
                token: that.token,
				type_id: type_id
			};
			if(level_id){
				params.level_id = level_id
			}
			if(area_name){
				params.area_name = area_name
				params.area_level = area_name.length
			}
			
            console.log('params')
			console.log(params)
			// 获取地图数据
            that.$api.map.areaItem(params).then(res => {
                // console.log('1')
                if (res.code == 200) {
                    that.dataList = res.result.cateList
					var newD = that.dataList
					var arr1 = new Array()
					var arr2 = new Array()
					for(var i in newD){
						var str = newD[i].name+'('+ newD[i].num + ')'
						if(that.getStrLength(str)>12){
							newD[i].span = 2
							arr1.push(newD[i])
						}else{
							newD[i].span = 1
							arr2.push(newD[i])
						}
					}
					that.dataList = arr1.concat(arr2)
					console.log('调了getData')
					console.log(that.dataList)
				}
			})
			// 默认覆盖物
			if(this.init){
				that.defaultAreaMarker()
				that.str = '北京'
			}
        },
        // 项目分类
        getTypeList(callback) {
			var params = {
				token: this.token
			}
            this.$api.map.itemType(params).then(res => {
                if (res.code == 200) {
                    console.log('项目分类')
                    console.log(res)
					// this.typeList = res.result
					callback(res)
                }
            })
        },
        // 切换轮播项目时
        changeFun(e) {
			this.levelArr = [];
			this.dataList = [];
            console.log('===================')
			// console.log()
			this.str = null
			// 项目分类列表
			// var arr = this.typeList
			// var subArr = arr.splice(0,e)
			// var NewtypeList = arr.concat(subArr)
			// console.log("NewtypeList",NewtypeList)
			// this.typeList = NewtypeList
			for(var i in this.typeList){
				if(i == e){
					this.type_id = this.typeList[i].type_id
					this.currentName = this.typeList[i].name
					break
					console.log('切换轮播项目 type_id',this.type_id)
				}
			}
			// 对应颜色
            if (this.type_id == 0) {
                this.color = {
					'top1': 'rgba(219, 31, 31, 1)',
                }
            }
            if (this.type_id == 1) {
                this.color = {
					// 'top1': 'rgba(255, 176, 51, 1)',
					'top1':'#fd851a'
				}
            }
            if (this.type_id == 2) {
				this.color = {
					// 'top1': 'rgba(71, 113, 253, 1)',
					'top1': 'rgb(64, 202, 140)'
				}
            }
            if (this.type_id == 3) {
				this.color = {
					// 'top1': 'rgba(64, 202, 140, 1)',
					'top1': '#EB59FF',
				}              
            }
            if (this.type_id == 4) {
				this.color = {
					// 'top1': 'rgba(255, 95, 20, 1)',
					'top1': 'rgba(64, 202, 140, 1)'
				}
			}
			
			//
			this.getLevelList(e)
			// this.getData(e,this.level_id)
			this.diaoqi()
			// 切换大分类时,重新渲染全国区域聚合(未与所选具体哪个省结合),所以把area_name清一下
			this.area_name = null
        },
        clickPrev() {
            this.$refs.swipe.prev()
        },
        clickNext() {
            this.$refs.swipe.next()
        },
        // 去项目列表页面
        goItem(item) {
            console.log('item')
			console.log(item)
			var levelIdList = new Array(),
			cateIdList = new Array(),
			areaNameList = new Array();
			levelIdList.push(this.level_id)
			cateIdList.push(item.id)
			var searchParams = {
				type_id: this.type_id, // 例如 非遗 百村id
				levelIdList: levelIdList, // 等级id 例如 非遗国家级
				cateIdList: cateIdList // 例如 民间文学id
			}
            if (this.areaList) {
				searchParams.areaNameList = this.areaList
            }
			console.log('searchParams',searchParams)
			localStorage.setItem('searchParams',JSON.stringify(searchParams))
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl+"/item/index"
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
					path: '/item/index'
				})
            }
            
		},
		// 项目详情
        goItemInfo(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl+"/item/info"
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
					path: "/item/detail",
					query: {
						id: id
					}
				});
            }
		},
		// 项目级别
		getLevelList(type_id){
			this.levelArr = []
			var params = {
				page: 1,
				size: 999,
				type_id: type_id
			}
			this.$api.map.levelList(params).then(res=>{
				if(res.code == 200){
					var arr = res.result.list
					// this.levelArr = res.result.list
					if(arr.length>0){
						this.levelArr = arr
						this.level_id = arr[0].id
						console.log('level列表')
						console.log(this.level_id)
						// 拿到当前的lever_id 去获取中国地图
						this.getData(type_id,this.level_id) // null,'init'
					}else{
						this.getData(type_id)
					}
				}
			})
		},
		// 切换level
		changeLevel(name){
			console.log(name)
			this.getData(this.type_id,this.level_id,this.area_name)
		},
		// 数组转换格式 适用于地图
		formatArr(data){
			// var data = [["37.7350987", "115.698786"],["18.2582452", "109.518642"],["40.8230745", "111.771826"],["30.7756831", "111.331458"]]
			// data.map(function(item){
			// 	console.log(item)
			// })
			var dataArr = []
			for(var i in data){
				dataArr.push(data[i].toString())
			}
			// console.log(dataArr)
			return dataArr
		},
		// 点击左侧图标
		clicksearchleft(){
			// 没有左侧图标
			return;
		},
		// 触发focus
		showFullScreenSearchPage(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?routeName=map-quanguo&type_id=" + this.type_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/search/index" + p
                    },
                };
                this.$bridge.callhandler( "sdjy://public/openNewWebView", params, (data) => {

					}
                );
            } else {
                this.$router.push({
					path: '/search/index',
					query: {
						routeName: 'map-quanguo',
						type_id: this.type_id
					}
				})
            }
			
		},
		// 点击右侧图标
		clicksearchright(){
			// 没有右侧图标
			return;
		},
		// 再次点击全国时
		goBackQuanguo(){
			var that = this
			that.str = null
			that.map.clearMap()
			that.map.setZoom(2)
			that.map.setCenter([103.984424,41.208757])
			console.log('type_id',that.type_id)
			console.log('level_id',that.level_id)
			that.getData(that.type_id,that.level_id)
		},
		// 查字符串长度, 区分中英文 中文2个字符 英文1个字符
		getStrLength(str){
			var len = 0;  
			for (var i=0; i<str.length; i++) {  
				if (str.charCodeAt(i)>127 || str.charCodeAt(i)==94) {  
				len += 2;  
				} else {  
				len ++;  
				}  
			}  
			return len;  
		},
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
		shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: '北京中医健康服务体系地图', // 分享标题
					desc: '北京中医健康服务体系地图', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 默认选中北京,添加覆盖物
		defaultAreaMarker(){
			// console.log('调了吗22222222222')
			var that = this
			var params = {
				token: that.token,
				type_id: that.type_id,
				area_name: ['北京'],
				area_level: 1,
				level_id: that.level_id
			}
			console.log('参数2222222',params)
			that.$api.map.areaItem(params).then(res => {
					// console.log('1')
					if (res.code == 200) {
						console.log('res')
						console.log(res)
						var markers = []
						var markerGroups = res.result.itemList
						that.dataList = res.result.cateList;
						// 排序
						var newD = that.dataList
						var arr1 = new Array()
						var arr2 = new Array()
						for(var i in newD){
							var str = newD[i].name+'('+ newD[i].num + ')'
							if(that.getStrLength(str)>12){
								newD[i].span = 2
								arr1.push(newD[i])
							}else{
								newD[i].span = 1
								arr2.push(newD[i])
							}
						}
						that.dataList = arr1.concat(arr2)

						// console.log('地图坐标点')
						// console.log(this.markerGroups)
						console.log('覆盖物组数据22222222')
						console.log(markerGroups)
						// console.log()
						that.map.setZoom(8)
						that.map.setCenter([116.340279,40.090361])
						// 添加覆盖物
						for(var i in markerGroups){
								// 创建点实例
								var marker = new AMap.Marker({
									position: new AMap.LngLat(markerGroups[i].xcoordinate,markerGroups[i].ycoordinate),
									icon: that.type_id == 1 ? that.mapIcons.icon4 : that.type_id == 2 ? that.mapIcons.icon3 : that.type_id == 3 ? that.mapIcons.icon5 : that.mapIcons.icon0,
									extData: {
										id: markerGroups[i].id,
										title: markerGroups[i].title
									},
									map:that.map
								})
								markers.push(marker);
						}
						// console.log('markers')
						// console.log(markers)
						// 给覆盖物绑定事件
						for(var i in markers){
							markers[i].on('click',function(e){
								console.log('click')
								console.log(e.target.getExtData())
								that.goItemInfo(e.target.getExtData().id)
							})
						}
						// 清除地图上的所有覆盖物
						that.map.clearMap(); 
						// 给当前区域加覆盖物
						var overlayGroups = new AMap.OverlayGroup(markers);
						that.map.add(overlayGroups);
					}
				})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#container {
	/* height: 60vh; */
    height: 62vh;
}
/deep/.amap-icon img{
	width:0.32rem;
	height:0.56rem;
}
.page-search .van-row{
	align-items: flex-start;
}
</style>
